import React, { useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import API from '../Services/Advance'
import AdvanceList from "../Components/AdvanceList";


const Advance = () => {
    const [error, setError] = useState({});
    const [advance, setAdvance] = useState("");

    const handleFieldChange = (e) => {
        const value = e.target.value;
        setAdvance(value);

        if (value.trim()) {
            setError((prevErrors) => {
                const updatedErrors = { ...prevErrors };
                delete updatedErrors.advance;
                return updatedErrors;
            });
        }
    };

    const validateFields = () => {
        const errors = {};
        const trimmedValue = advance.trim();

        if (!trimmedValue) {
            errors.advance = "Advance is required";
        } else if (!/^\d+$/.test(trimmedValue)) {
            errors.advance = "Advance must be numeric only";
        } else {
            const numericValue = parseInt(trimmedValue, 10);
            if (numericValue < 1 || numericValue > 99) {
                errors.advance = "Advance must be between 1 and 99";
            }
        }

        setError(errors);
        return Object.keys(errors).length === 0;
    };

    const saveAdvanceData = async () => {
        const payload = {
            advance: advance
        }
        //console.log("payload data...", payload)
        try {
            const response = await API.saveAdvance(payload)
            //console.log("response data...", response?.data)
            toast.success(response?.data?.message || "Advance created successfully!");
            setTimeout(() => window.location.reload(), 2000);
        } catch (error) {
            handleError(error);
            if (error.response.status == 403) {
                window.location.replace("/Login");
            }
            console.log("error", error)
        }

    }

    const handleError = (error) => {
        console.error("Error:", error);
        if (error.response) {
            toast.error(error.response.data?.message || `Error: ${error.response.status}`);
        } else if (error.request) {
            toast.error("No response from server. Please try again later.");

        } else {
            toast.error("Something went wrong. Please try again.");
        }
    };

    const handleSubmit = async () => {
        if (!validateFields()) return;
        saveAdvanceData()

    };

    const handleCancel = () => {
        setAdvance("");
        setError({});
    };

    return (
        <div>
            <div className="col-12 grid-margin stretch-card">
                <div className="card">
                    <div className="card-body">
                        <div className="forms-sample">
                            <div className="row">
                                <div className="col-md-6">
                                    <div className="form-group">
                                        <label htmlFor="advance">
                                            Advance (%) <span style={{ color: "red" }}>*</span>
                                        </label>
                                        <input
                                            type="text"
                                            className="form-control"
                                            id="advance"
                                            placeholder="Enter Advance"
                                            value={advance}
                                            onChange={handleFieldChange}
                                        />
                                        {error?.advance && (
                                            <span className="text-danger" style={{ fontSize: "12px" }}>
                                                {error.advance}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>
                            <div className="mt-3">
                                <button onClick={handleSubmit} type="submit" className="btn btn-primary">
                                    Submit
                                </button>
                                <button onClick={handleCancel} className="btn btn-light ms-2">
                                    Cancel
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <ToastContainer />
            <AdvanceList/>
        </div>
    );
};

export default Advance;
